import type { IAudienceMeta } from '@/Interfaces/Audiences/Audience.interface';
import type { IForecast } from '@/Interfaces/Forecaster/Forecast.interface';
import AudienceGroups from '@/components/Grid/AudienceGroups';
import HiddenDataChip from '@/components/Grid/HiddenDataChip';
import { formatAudienceExpression } from '@/helpers/audience/formatAudienceExpression';
import type { GridRenderCellParams } from '@mui/x-data-grid-pro';

const AudienceCell = (params: GridRenderCellParams<IForecast, IAudienceMeta>) => {
  const blockRows = params.row.audienceBlocksMeta ?? [];

  if (!blockRows.length) {
    return <AudienceGroups value={params.value} />;
  }

  return (
    <div className='flex justify-center items-center gap-2'>
      <HiddenDataChip
        label='Templates'
        hiddenData={
          <div>
            {blockRows.map((row, rowIndex) => (
              <div key={rowIndex}>
                {rowIndex > 0 && <p className='text-[#0C3]'>AND</p>}
                {row.map((block, blockIndex) => (
                  <p key={blockIndex}>
                    {blockIndex > 0 && <span className='text-[#F00]'>OR </span>}
                    <strong>{block.label}</strong>: {formatAudienceExpression(block.include, block.exclude)}
                  </p>
                ))}
              </div>
            ))}
          </div>
        }
      />
    </div>
  );
};

export default AudienceCell;
